import spartaUILayersUtility from "utilities/global/sparta-ui-layers-utility/5.7.8/js/sparta-ui-layers-utility";
import ahCawCommons from "utilities/login/ah-caw-commons-utility/2.4.1/js/ah-caw-commons-utility";
import Module from "utilities/global/sparta-module-utility/6.3.0/js/sparta-module-utility";
import spartaValidationFramework from "utilities/global/sparta-validation-framework/7.1.8/js/sparta-validation-framework";
import "utilities/vendor/jsencrypt/2.3.1/js/jsencrypt";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import spartaStyleUtility from "utilities/global/sparta-style-utility/3.2.4/js/sparta-style-utility";
import ahCawTransportUtility from "utilities/login/ah-caw-transport-utility/2.2.3/js/ah-caw-transport-utility";
import spartaInputUtility from "utilities/global/sparta-input-utility/12.1.1/js/sparta-input-utility";
import textInput from "utilities/helpers/helpers-text-inputs/4.1.2/js/helpers-text-inputs";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import Handlebars from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import cawEventsMasterUtility from "utilities/login/ah-caw-events-master-utility/4.5.3/js/ah-caw-events-master-utility";
import ahAuthcodeCommonsUtility from "utilities/login/ah-authcode-commons-utility/4.0.1/js/ah-authcode-commons-utility";
import spartaMessageUtility from "utilities/global/sparta-messaging-utility/2.1.7/js/sparta-messaging-utility";
import {default as AuthUtils} from "modules/login/ah-authcode-module/11.1.0/js/dep";
import spartaTemplates from "modules/login/ah-authcode-module/11.1.0/js/templates";
import "css!modules/login/ah-authcode-module/11.1.0/css/ah-authcode-module.scss.css";











export default class ahAuthcodeModuleJS extends Module {
  constructor(options) {
      super(options);

      this.ahOTACCommons = new ahAuthcodeCommonsUtility(
        {
          '$' : $,
          '_' : _,
          'cawCommons' : ahCawCommons,
          'cawEventsMaster' : cawEventsMasterUtility,
          'spartaUILayersUtility' : spartaUILayersUtility,
          'spartaMessageUtil' : new spartaMessageUtility(),
          'spartaValidationFramework' : spartaValidationFramework,
          'constructorParams' : options,
          'hb' : Handlebars,
          'jsEncrypt' : window.JSEncryptExports,
          'context': this
        }
      );

      this.ahOTACCommons.whatAmI();


      this.clientParams = options.clientParams;
      this.i18n = options.i18n;

      if (options && options['events-namespace']) {
          this['events-namespace'] = `:${options['events-namespace']}`;
          this.modalWindowContentID = 'ah-otp-widget-modalwindow-' + options["events-namespace"] + "-";
      } else {
          this['events-namespace'] = '';
          this.modalWindowContentID = 'ah-otp-widget-modalwindow-';
      }

      this.linkPrefix = options.linkPrefix;
      if(options.customError){
        this.CUSTOMERROR = options.customError;
      }
      this.ERRORS = options.ERRORS;
      this.publicKey = options.publicKey;
      if (typeof cX === 'function') {
          cX('onload');
      }
  }

  init(args = {}) {
    const self = this;


    this.ahOTACCommons
          .defineVars()
          .compileAllTemplates()
          .subscribeEvents()
          .bindEventHandlers()
          .bindThisContext();

    this.$moduleContext.spartaInputs();





  }
}
